import ContractsMileageAddRequest from "../../../../api/raily/contracts/mileage/add/contracts-mileage-add.request";
import ContractsMileageAddParams from "./contracts-mileage-add-params";

const create = (
  params: ContractsMileageAddParams,
): ContractsMileageAddRequest => {
  return {
    companyUuid: params.companyUuid,
    dietFullAfterHours: params.dietFullAfterHours,
    dietFullRate: params.dietFullRate,
    dietHalfAfterHours: params.dietHalfAfterHours,
    dietHalfRate: params.dietHalfRate,
    disabled: params.disabled,
    distanceRateCarGt900cm3: params.distanceRateCarGt900cm3,
    distanceRateCarLe900cm3: params.distanceRateCarLe900cm3,
    distanceRateCompanyVehicle: params.distanceRateCompanyVehicle,
    distanceRateMoped: params.distanceRateMoped,
    distanceRateMotorcycle: params.distanceRateMotorcycle,
    validSince: params.validSince,
    validTo: params.validTo,
  };
};

const contractsMileageAddParamsFactory = {
  create,
};

export default contractsMileageAddParamsFactory;
